var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'VideoDetail', params: { id: _vm.video.pk_post_file_id } }}},[_c('img',{staticClass:"masonry-img",attrs:{"src":_vm.video.poster}}),_vm._v(" "),_c('i',{staticClass:"material-icons video-btn-1",attrs:{"data-v-022d7da9":""}},[_vm._v("slideshow")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a196170","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/profile/ListVideo.vue
// module id = null
// module chunks = 